<template>
  <div class="ui-error-bar" @click="onClose">
      <slot></slot>
  </div>
</template>

<script>
export default {
    methods: {
        onClose() {
            this.$emit('close');
            this.$store.dispatch('showError', null);
        }
    }
}
</script>

<style scoped>
.ui-error-bar {
    background-color: #E2223B;
    color: #ededed;
    font-size: 2.1vh;
    text-align: center;

    width: 63vw;

    position: fixed;
    margin: auto;

    top: 6vh;

    left: 32vh;
    right: 0;
    z-index: 4242;
    border-radius: 1vh;
    padding: 0.8vh 0;

    animation: fadein 0.5s;
    transition: 0.4s;

    cursor: pointer;
}

.ui-error-bar:hover {
    transform: scale(1.1);
    transition: 0.4s;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
</style>